import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import BKUserSelect from '@/components/BKUserSelect.vue'
import { Studio, StudioUser, SearchParams } from '@/modules/Studios/types'
import { StudioApi } from '@/enitites/studio'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateStudioStudents',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as {
  studio: Studio
};



const students = ref<StudioUser[]>([])
const paginationParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
})

// Computed properties
const excludedStudentIds = computed(() => students.value.map((student) => student.id))

// Students methods
const fetchStudents = async () => {
  if (!props.studio) return
  students.value = await StudioApi.fetchStudioStudents(props.studio.id, paginationParams.value)
}

const addStudent = async (user: StudioUser) => {
  if (!props.studio) return
  const resp = await StudioApi.addStudioStudent(props.studio.id, user.id)
  if (resp) {
    students.value.push(user)
  }
}

const removeStudent = async (user: StudioUser) => {
  if (!props.studio) return
  const resp = await StudioApi.deleteStudioStudentById(props.studio.id, user.id)
  if (resp) {
    students.value = students.value.filter((student) => student.id !== user.id)
  }
}

onMounted(async () => {
  await fetchStudents()
})

return { __sfc: true,props, students, paginationParams, excludedStudentIds, fetchStudents, addStudent, removeStudent, BKUserSelect }
}

})